import { StrategicRecommendation, StrategicRecommendationFeature } from 'types'
import { FeatureIcon } from './FeatureIcon'
import { FEATURE_LABELS } from './constants'
import Styles from './FeatureRecommendations.module.scss'
import { Text } from 'blaze-ui/Text/Text'
import { ResponsiveDesign } from '../../components/ResponsiveDesign'
import { Heading } from 'blaze-ui/Heading/Heading'
import { ChevronRightSmall } from 'blaze-ui/icons/24'
import { Pressable } from '@react-aria/interactions'
import { useRootStore } from 'stores/RootStore'
import { DetailsDrawer } from './DetailsDrawer/DetailsDrawer'

interface Props {
  feature: StrategicRecommendationFeature
  recommendations: StrategicRecommendation[]
  brandKitId: number
  channelType: StrategicRecommendation['channel_type']
}

export const FeatureRecommendations = ({ channelType, brandKitId, feature, recommendations }: Props) => {
  const { drawersStore } = useRootStore()

  const openDetailsDrawer = () => {
    drawersStore.openDrawer(DetailsDrawer, {
      channelType,
      feature,
      brandKitId,
    })
  }

  return (
    <>
      <ResponsiveDesign.Mobile>
        <Pressable onPress={openDetailsDrawer}>
          <div className={Styles.featureRecommendations}>
            <div className={Styles.header}>
              <Heading level={5}>{FEATURE_LABELS[feature as StrategicRecommendationFeature]}</Heading>
              <ChevronRightSmall size={20} color="var(--dark-25)" />
            </div>
            <ul className={Styles.list}>
              {recommendations.map((recommendation, i) => (
                <li key={i}>
                  <Text variant="secondary" color="var(--dark-80)">
                    {recommendation.recommendation}
                  </Text>
                </li>
              ))}
            </ul>
          </div>
        </Pressable>
      </ResponsiveDesign.Mobile>

      <ResponsiveDesign.Desktop>
        <tr key={feature}>
          <td className={Styles.featureCell}>
            <div className={Styles.featureContent}>
              <FeatureIcon feature={feature as StrategicRecommendationFeature} />
              <Text variant="largeList" color="var(--dark-80)">
                {FEATURE_LABELS[feature as StrategicRecommendationFeature]}
              </Text>
            </div>
          </td>
          <td>
            <ul className={Styles.list}>
              {recommendations.map((recommendation, i) => (
                <li key={i}>
                  <Text variant="primary" color="var(--dark-80)">
                    {recommendation.recommendation}
                  </Text>
                </li>
              ))}
            </ul>
          </td>
        </tr>
      </ResponsiveDesign.Desktop>
    </>
  )
}
